// extracted by mini-css-extract-plugin
export default {"root":"ContactPage_root__VvnLm","tabs":"ContactPage_tabs__kowio","panel-wrapper":"ContactPage_panel-wrapper__z8aJW"};